import React, { Component } from 'react';
import { IntlProvider, FormattedDate, FormattedNumber, FormattedTime, addLocaleData } from 'react-intl';
import PropTypes from 'prop-types';
import it from 'react-intl/locale-data/it';

import "../css/event.css";

addLocaleData([...it]);

class Event extends Component {
    render() {
        const defaultPosterUrl = "/img/concerts/poster_bkg.jpg";
        const locationAddress = this.props.event.location.place ?
            <span><i>{this.props.event.location.place}</i> - {this.props.event.location.address}, {this.props.event.location.city}</span>
            :
            (this.props.event.location.address ?
                <span>{this.props.event.location.address}, {this.props.event.location.city}</span>
                : <span>{this.props.event.location.city}</span>)
            ;
        let posterUrl = this.props.event.posterurl ? "url(" + this.props.event.posterurl + ")" : "url(" + defaultPosterUrl + ")";
        return (
            <IntlProvider locale="it">
                <div id={'event-' + this.props.event.id} className="row m-0 mb-4 eventitem rounded">
                    <div className="col-sm-3 text-center p-0">
                        <div className="card card-image no-box" style={{ backgroundImage: posterUrl, height: "100%" }}>
                            <div className="text-white text-center d-flex align-items-center rgba-black-medium py-3 px-2 rounded-left" style={{ height: "100%" }}>
                                <div style={{ width: "100%" }} className="d-flex flex-column">
                                    <div>
                                        <FormattedDate value={this.props.event.startdatetime} weekday="long">
                                            {(formattedDate) => (<span className="">{formattedDate}</span>)}
                                        </FormattedDate>
                                        <br />
                                        <h3 className="py-1 mb-0 font-bold">
                                            <FormattedDate value={this.props.event.startdatetime} day="2-digit" month="long">
                                                {(formattedDate) => (<span className="">{formattedDate}</span>)}
                                            </FormattedDate>
                                        </h3>
                                        <FormattedDate value={this.props.event.startdatetime} year="numeric" />
                                    </div>
                                    <div className="mt-auto">
                                        <hr className="thin" />
                                        <div className="font-bold mt-1" style={{ fontSize: "1.1em" }}>{this.props.event.location.city}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-9 d-flex flex-column">
                        <div className="row">
                            <div className="col-12">
                                <h4 className="mt-3 font-bold accent-cl">{this.props.event.title}</h4>
                            </div>
                        </div>
                        <div className="row" style={{ fontFamily: 'Roboto' }}>
                            <div className="col-sm-12">
                                <i className="fas fa-map-marker detailicon fa-fw"></i>{locationAddress}
                            </div>
                        </div>
                        <div className="row" style={{ fontFamily: 'Roboto' }}>
                            <div className="col-sm-12 pt-1">
                                <i className="far fa-clock detailicon fa-fw"></i>
                                <FormattedTime value={this.props.event.startdatetime} /> - <FormattedTime value={this.props.event.enddatetime} />
                            </div>
                        </div>
                        {
                            this.props.event.price &&
                            <div className="row" style={{ fontFamily: 'Roboto' }}>
                                <div className="col-12 pt-1">
                                    <i className="fas fa-euro-sign detailicon fa-fw"></i>
                                    {
                                        this.props.event.price > 0 &&
                                        <FormattedNumber value={this.props.event.price} minimumFractionDigits={2} />
                                    }
                                    {
                                        this.props.event.price === "0" &&
                                        "Ingresso libero"
                                    }
                                    {
                                        isNaN(this.props.event.price) &&
                                        "Offerta libera"
                                    }
                                </div>
                            </div>
                        }
                        {
                            this.props.event.description &&
                            <div className="row" style={{ fontFamily: 'Roboto' }}>
                                <div className="col-12 pt-1">
                                    <i className="fas fa-info detailicon fa-fw"></i>{this.props.event.description}
                                </div>
                            </div>
                        }
                        <div className="row mt-auto">
                            <div className="col-sm-12 text-center">
                                <a className="btn-floating btn-sm primary-bkg" target="_blank" href={"http://maps.google.com/maps?q=" + encodeURIComponent(this.props.event.location.place + ', ' + this.props.event.location.address + ', ' + this.props.event.location.city)}>
                                    <i className="fas fa-map btn-floating-icon" title="Visualizza sulla mappa di Google"></i>
                                </a>
                                {
                                    this.props.event.posterurl && this.props.event.zoomposter && <span className="btn-floating btn-sm primary-bkg">
                                        <i className="fas fa-image btn-floating-icon" title="Visualizza locandina">
                                        </i></span>
                                }
                                {
                                    this.props.event.fb_link &&
                                    <a className="btn-floating btn-sm" style={{ backgroundColor: "#3b5998" }} href={this.props.event.fb_link} title="Apri pagina evento facebook" target="_blank"><i className="fab fa-facebook-f fa-fw btn-floating-icon"></i></a>
                                }
                                {
                                    this.props.event.external_link &&
                                    <a className="btn-floating btn-sm primary-bkg" href={this.props.event.external_link} title="Apri link esterno" target="_blank"><i className="fas fa-external-link-alt fa-fw btn-floating-icon"></i></a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </IntlProvider>
        );
    }
}

Event.propTypes = {
    event: PropTypes.object.isRequired
};

export default Event;


// WEBPACK FOOTER //
// ./src/components/Event.js